import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import ScrollToTop from '../components/ScrollToTop';

const ReturnPolicy: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);

  return (
    <>

      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>

      <PopupSearch />

      <main className="main">

        <Header />

        {/* Breadcumb */}

        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-4.jpg')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        >

          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">

            <div className="breadcumb-content">

              <h1 className="breadcumb-title">
                Return & Refund Policy
              </h1>

              <div className="breadcumb-menu-wrap">

                <ul className="breadcumb-menu">

                  <li>
                    <Link to="/">
                      Home
                    </Link>
                  </li>

                  <li>
                    Return & Refund Policy
                  </li>

                </ul>

              </div>

            </div>

          </div>

        </div>

        {/* Policy Section */}

        <section className="space-top space-extra-bottom">

          <div className="container">

            <div className="row justify-content-center">

              <div className="col-lg-10">

                <div className="vs-blog blog-style1">

                  <div className="blog-content">

                    <h3 className="blog-title">
                      Easy Return Support
                    </h3>

                    <p className="blog-text">

                      We want you to love every purchase
                      from Ninesister Jewels. If there is
                      an issue with your order, you can
                      request a return within{" "}

                      <strong>
                        7 days
                      </strong>

                      {" "}of delivery.

                    </p>

                    <h3 className="blog-title">
                      Return Eligibility
                    </h3>

                    <ul className="list-style1">

                      <li>
                        Item must be unused and in
                        original condition.
                      </li>

                      <li>
                        Original packaging and tags
                        should be intact.
                      </li>

                      <li>
                        Unboxing video is recommended
                        for damaged/wrong item claims.
                      </li>

                      <li>
                        Return request must include
                        order ID and reason.
                      </li>

                    </ul>

                    <h3 className="blog-title">
                      Non-Returnable Items
                    </h3>

                    <ul className="list-style1">

                      <li>
                        Custom-made or personalized
                        jewellery.
                      </li>

                      <li>
                        Items damaged due to
                        mishandling after delivery.
                      </li>

                      <li>
                        Products bought in final
                        sale/clearance campaigns.
                      </li>

                    </ul>

                    <h3 className="blog-title">
                      Refund Timeline
                    </h3>

                    <p className="blog-text">

                      After quality check approval,
                      refunds are processed within{" "}

                      <strong>
                        5-7 business days
                      </strong>

                      {" "}to the original payment
                      method. COD orders are refunded
                      via bank transfer/UPI after
                      verification.

                    </p>

                    <h3 className="blog-title">
                      Exchange Option
                    </h3>

                    <p className="blog-text">

                      Size or design exchange is
                      available for eligible products,
                      subject to stock availability.
                      Exchange shipping timelines may
                      vary by location.

                    </p>

                    <h3 className="blog-title">
                      Need Help?
                    </h3>

                    <p className="blog-text">

                      Email us at{" "}

                      <a href="mailto:Ninesisters0819@gmail.com">
                        Ninesisters0819@gmail.com
                      </a>

                      {" "}or call{" "}

                      <a href="tel:+918928218258">
                        (+91) 89282 18258
                      </a>

                      . Our team will guide you through
                      the complete return or refund
                      process.

                    </p>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

        <Footer />

      </main>

      <ScrollToTop />

    </>
  );
};

export default ReturnPolicy;